































import { Component, Vue, Prop } from 'vue-property-decorator';
import Datagrid from '@/components/default/Datagrid.vue';
import Card from '@/components/default/Card.vue';
import Popup from '@/components/default/Popup.vue';
import notificationService from '@/services/notificationService';
import CalculateSummaryService from '../services/CalculateSummaryService';

import { IMeasurementDto, MeasurementRoom } from '@/data/web-api-client';
import { DxForm, DxSimpleItem, DxLabel, DxRequiredRule } from 'devextreme-vue/form';

@Component({
  components: {
    Datagrid,
    Card,
    Popup,
    DxForm,
    DxSimpleItem,
    DxLabel,
    DxRequiredRule,
  },
})
export default class MeasurementsSummary extends Vue {
  @Prop({ required: true })
  private data!: IMeasurementDto;

  @Prop({required: false, default: false})
  disabled!: boolean;

  private showPopup: boolean = false;
  private formdata: {
    oldArticleId: string;
    newArticleId: string;
  } = {
    oldArticleId: '',
    newArticleId: '',
  };

  private change() {
    const validationResult = (this.$refs.form as any).instance.validate();
    if (validationResult.isValid) {
      this.$emit('replace', this.formdata);
      setTimeout(() => {
        this.showPopup = false;
      }, 200);
    } else {
      notificationService.invalidForm();
    }
  }

  get oldArticlesOptions() {
    return {
      items: this.articles,
      displayExpr: 'name',
      valueExpr: 'id',
      disabled: true,
      searchEnabled: true,
    };
  }

  get articlesOptions() {
    return {
      items: this.articles,
      displayExpr: 'name',
      valueExpr: 'id',
      searchEnabled: true,
    };
  }

  get articles() {
    return this.$store.getters['articles/items'];
  }

  get rawmaterials() {
    return this.$store.getters['rawmaterials/items'];
  }

  get summary() {
    return CalculateSummaryService.summary(this.data, this.articles, this.rawmaterials);
  }

  get columns() {
    const self = this;
    const columns: any = [
      {
        dataField: 'id',
        caption: 'Code',
        lookup: {
          dataSource: this.articles,
          displayExpr(val: any) {
            return `${val.name}: ${val.description}`;
          },
          allowClearing: true,
          valueExpr: 'id',
        },
        validationRules: [{ type: 'required', message: 'Code is verplicht' }],
      },
      {
        dataField: 'amount',
        alignment: 'left',
        caption: 'Totaal',
        calculateDisplayValue(value: any) {
          let result = CalculateSummaryService.calculateAmountFromLine(value);
          result = Math.round(result * 100) / 100;
          return value.measuringUnit ? result + ' ' + value.measuringUnit : result;
        },
      },
    ];

      if (!this.disabled) {
        columns.push({
          type: 'buttons',
          buttons: [
            {
              hint: 'Vervangen',
              icon: 'fas fa-sync',
              onClick: (e: any) => {
                self.formdata.oldArticleId = e.row.data.id;
                self.formdata.newArticleId = '';
                self.showPopup = true;
                // REPLACE
              },
            },
            {
              hint: 'Verwijderen',
              icon: 'fas fa-trash',
              onClick: (e: any) => {
                if (!confirm('Bent u zeker? Onderliggende codes worden ook verwijderd!')) {
                  return;
                }

                this.data.rooms!.forEach((room) => {
                  const idList: string[] = [];
                  room.usedArticles!.forEach((usedArticle) => {
                    if (usedArticle.articleId === e.row.data.id) {
                      idList.push(usedArticle.lineId!);
                    }
                  });

                  idList.forEach((id) => {
                    let index = room.usedArticles!.findIndex((o) => o.lineId === id);
                    if (index !== -1) {
                      this.removeChildLines(room, id);
                      index = room.usedArticles!.findIndex((o) => o.lineId === id);
                      room.usedArticles!.splice(index, 1);
                    }
                  });
                });
              },
            },
          ]
        });
      }

    return columns;
  }

  private removeChildLines(room: MeasurementRoom, lineId: string) {
    const children = room.usedArticles!.filter((o) => o.parentLineId === lineId);
    if (!children || children.length === 0) {
      return;
    }

    children.forEach((child) => {
      this.removeChildLines(room, child.lineId!);
      const index = room.usedArticles!.findIndex((o) => o.lineId === child.lineId);
      if (index !== -1) {
        room.usedArticles!.splice(index, 1);
      }
    });
  }

  get rawMaterialsColumns() {
    return [
      {
        dataField: 'id',
        caption: 'Grondstof',
        lookup: {
          dataSource: this.rawmaterials,
          displayExpr(val: any) {
            return `${val.name}`;
          },
          allowClearing: true,
          valueExpr: 'id',
        },
      },
      {
        alignment: 'left',
        caption: 'Totaal',
        calculateDisplayValue(value: { id: string; amount: number; measuringUnit: string; convertionsRate: number; defaultOrderMeasuringUnit: string }) {
          const amount = Math.round(value.amount * 100) / 100;
          return value.measuringUnit ? amount + ' ' + value.measuringUnit : amount;
        },
      },
      {
        alignment: 'left',
        caption: 'Bestelhoeveelheid',
        calculateDisplayValue(value: { id: string; amount: number; measuringUnit: string; convertionsRate: number; defaultOrderMeasuringUnit: string }) {
          const amount = Math.round(value.amount * value.convertionsRate * 100) / 100;
          return value.defaultOrderMeasuringUnit ? amount + ' ' + value.defaultOrderMeasuringUnit : amount;
        },
      },
    ];
  }
}
